/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OrderOrigin } from './OrderOrigin';
import {
    OrderOriginFromJSON,
    OrderOriginFromJSONTyped,
    OrderOriginToJSON,
    OrderOriginToJSONTyped,
} from './OrderOrigin';
import type { OrderType } from './OrderType';
import {
    OrderTypeFromJSON,
    OrderTypeFromJSONTyped,
    OrderTypeToJSON,
    OrderTypeToJSONTyped,
} from './OrderType';
import type { Address } from './Address';
import {
    AddressFromJSON,
    AddressFromJSONTyped,
    AddressToJSON,
    AddressToJSONTyped,
} from './Address';
import type { HeoCustomerOrderNumber } from './HeoCustomerOrderNumber';
import {
    HeoCustomerOrderNumberFromJSON,
    HeoCustomerOrderNumberFromJSONTyped,
    HeoCustomerOrderNumberToJSON,
    HeoCustomerOrderNumberToJSONTyped,
} from './HeoCustomerOrderNumber';

/**
 * 
 * @export
 * @interface CustomerOrderDetailsExport
 */
export interface CustomerOrderDetailsExport {
    /**
     * 
     * @type {string}
     * @memberof CustomerOrderDetailsExport
     */
    id: string;
    /**
     * 
     * @type {HeoCustomerOrderNumber}
     * @memberof CustomerOrderDetailsExport
     */
    number: HeoCustomerOrderNumber;
    /**
     * 
     * @type {string}
     * @memberof CustomerOrderDetailsExport
     */
    customerReference: string;
    /**
     * 
     * @type {Date}
     * @memberof CustomerOrderDetailsExport
     */
    createdAt: Date;
    /**
     * 
     * @type {number}
     * @memberof CustomerOrderDetailsExport
     */
    total: number;
    /**
     * 
     * @type {OrderOrigin}
     * @memberof CustomerOrderDetailsExport
     */
    orderOrigin?: OrderOrigin;
    /**
     * 
     * @type {OrderType}
     * @memberof CustomerOrderDetailsExport
     */
    orderType?: OrderType;
    /**
     * 
     * @type {Address}
     * @memberof CustomerOrderDetailsExport
     */
    shippingAddress?: Address;
    /**
     * 
     * @type {number}
     * @memberof CustomerOrderDetailsExport
     */
    itemPricePerUnit: number;
    /**
     * 
     * @type {number}
     * @memberof CustomerOrderDetailsExport
     */
    itemTotal: number;
    /**
     * 
     * @type {string}
     * @memberof CustomerOrderDetailsExport
     */
    itemHeoPositionNumberCompanyCode: string;
    /**
     * 
     * @type {number}
     * @memberof CustomerOrderDetailsExport
     */
    itemHeoPositionNumberNumber: number;
    /**
     * 
     * @type {CustomerOrderDetailsExportItemStatusEnum}
     * @memberof CustomerOrderDetailsExport
     */
    itemStatus?: CustomerOrderDetailsExportItemStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof CustomerOrderDetailsExport
     */
    itemDiscount: number;
    /**
     * 
     * @type {string}
     * @memberof CustomerOrderDetailsExport
     */
    itemCustomerItemReference: string;
    /**
     * 
     * @type {number}
     * @memberof CustomerOrderDetailsExport
     */
    itemTax: number;
    /**
     * 
     * @type {boolean}
     * @memberof CustomerOrderDetailsExport
     */
    itemFiled: boolean;
    /**
     * 
     * @type {string}
     * @memberof CustomerOrderDetailsExport
     */
    itemProductNumber: string;
    /**
     * 
     * @type {number}
     * @memberof CustomerOrderDetailsExport
     */
    itemQuantity: number;
    /**
     * 
     * @type {number}
     * @memberof CustomerOrderDetailsExport
     */
    itemShippedQuantity: number;
    /**
     * 
     * @type {number}
     * @memberof CustomerOrderDetailsExport
     */
    itemAcceptedQuantity: number;
    /**
     * 
     * @type {string}
     * @memberof CustomerOrderDetailsExport
     */
    productName: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerOrderDetailsExport
     */
    productGtin: string;
}


/**
 * @export
 */
export const CustomerOrderDetailsExportItemStatusEnum = {
    Unconfirmed: 'UNCONFIRMED',
    Confirmed: 'CONFIRMED',
    Other: 'OTHER'
} as const;
export type CustomerOrderDetailsExportItemStatusEnum = typeof CustomerOrderDetailsExportItemStatusEnum[keyof typeof CustomerOrderDetailsExportItemStatusEnum];


/**
 * Check if a given object implements the CustomerOrderDetailsExport interface.
 */
export function instanceOfCustomerOrderDetailsExport(value: object): value is CustomerOrderDetailsExport {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('number' in value) || value['number'] === undefined) return false;
    if (!('customerReference' in value) || value['customerReference'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('itemPricePerUnit' in value) || value['itemPricePerUnit'] === undefined) return false;
    if (!('itemTotal' in value) || value['itemTotal'] === undefined) return false;
    if (!('itemHeoPositionNumberCompanyCode' in value) || value['itemHeoPositionNumberCompanyCode'] === undefined) return false;
    if (!('itemHeoPositionNumberNumber' in value) || value['itemHeoPositionNumberNumber'] === undefined) return false;
    if (!('itemDiscount' in value) || value['itemDiscount'] === undefined) return false;
    if (!('itemCustomerItemReference' in value) || value['itemCustomerItemReference'] === undefined) return false;
    if (!('itemTax' in value) || value['itemTax'] === undefined) return false;
    if (!('itemFiled' in value) || value['itemFiled'] === undefined) return false;
    if (!('itemProductNumber' in value) || value['itemProductNumber'] === undefined) return false;
    if (!('itemQuantity' in value) || value['itemQuantity'] === undefined) return false;
    if (!('itemShippedQuantity' in value) || value['itemShippedQuantity'] === undefined) return false;
    if (!('itemAcceptedQuantity' in value) || value['itemAcceptedQuantity'] === undefined) return false;
    if (!('productName' in value) || value['productName'] === undefined) return false;
    if (!('productGtin' in value) || value['productGtin'] === undefined) return false;
    return true;
}

export function CustomerOrderDetailsExportFromJSON(json: any): CustomerOrderDetailsExport {
    return CustomerOrderDetailsExportFromJSONTyped(json, false);
}

export function CustomerOrderDetailsExportFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomerOrderDetailsExport {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'number': HeoCustomerOrderNumberFromJSON(json['number']),
        'customerReference': json['customerReference'],
        'createdAt': (new Date(json['createdAt'])),
        'total': json['total'],
        'orderOrigin': json['orderOrigin'] == null ? undefined : OrderOriginFromJSON(json['orderOrigin']),
        'orderType': json['orderType'] == null ? undefined : OrderTypeFromJSON(json['orderType']),
        'shippingAddress': json['shippingAddress'] == null ? undefined : AddressFromJSON(json['shippingAddress']),
        'itemPricePerUnit': json['itemPricePerUnit'],
        'itemTotal': json['itemTotal'],
        'itemHeoPositionNumberCompanyCode': json['itemHeoPositionNumberCompanyCode'],
        'itemHeoPositionNumberNumber': json['itemHeoPositionNumberNumber'],
        'itemStatus': json['itemStatus'] == null ? undefined : json['itemStatus'],
        'itemDiscount': json['itemDiscount'],
        'itemCustomerItemReference': json['itemCustomerItemReference'],
        'itemTax': json['itemTax'],
        'itemFiled': json['itemFiled'],
        'itemProductNumber': json['itemProductNumber'],
        'itemQuantity': json['itemQuantity'],
        'itemShippedQuantity': json['itemShippedQuantity'],
        'itemAcceptedQuantity': json['itemAcceptedQuantity'],
        'productName': json['productName'],
        'productGtin': json['productGtin'],
    };
}

export function CustomerOrderDetailsExportToJSON(json: any): CustomerOrderDetailsExport {
    return CustomerOrderDetailsExportToJSONTyped(json, false);
}

export function CustomerOrderDetailsExportToJSONTyped(value?: CustomerOrderDetailsExport | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'number': HeoCustomerOrderNumberToJSON(value['number']),
        'customerReference': value['customerReference'],
        'createdAt': value['createdAt'].toISOString(),
        'total': value['total'],
        'orderOrigin': OrderOriginToJSON(value['orderOrigin']),
        'orderType': OrderTypeToJSON(value['orderType']),
        'shippingAddress': AddressToJSON(value['shippingAddress']),
        'itemPricePerUnit': value['itemPricePerUnit'],
        'itemTotal': value['itemTotal'],
        'itemHeoPositionNumberCompanyCode': value['itemHeoPositionNumberCompanyCode'],
        'itemHeoPositionNumberNumber': value['itemHeoPositionNumberNumber'],
        'itemStatus': value['itemStatus'],
        'itemDiscount': value['itemDiscount'],
        'itemCustomerItemReference': value['itemCustomerItemReference'],
        'itemTax': value['itemTax'],
        'itemFiled': value['itemFiled'],
        'itemProductNumber': value['itemProductNumber'],
        'itemQuantity': value['itemQuantity'],
        'itemShippedQuantity': value['itemShippedQuantity'],
        'itemAcceptedQuantity': value['itemAcceptedQuantity'],
        'productName': value['productName'],
        'productGtin': value['productGtin'],
    };
}

